import React from 'react';
import Image from "./Image";

export default class ImageRotation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSource: 0,
            intervalID: '',
            enabled : true,
            rotationEnable : false
        };
        this.startRotation = this.startRotation.bind(this);
        this.stopRotation = this.stopRotation.bind(this);
    }

    startRotation() {
        let internalId = setInterval(() => {
            this.setState({rotationEnable : true, currentSource: (this.state.currentSource < this.props.srcs.length - 1) ? this.state.currentSource + 1 : 0});
        }, this.props.interval);
        this.setState({internalId, currentSource: 0});
    }

    stopRotation() {
        clearInterval(this.state.internalId);
        this.setState({rotationEnable : false, currentSource: 0});
    }

    render() {
        return <Image
            src={this.props.videoCoverUrl && !this.state.rotationEnable ? this.props.videoCoverUrl : this.props.srcs[this.state.currentSource]}
            onLoad={this.props.onLoad}
            onError={(event)=>{
                this.props.onError(event);
                this.setState({enabled : false})
            }}
            alt={this.props.alt}
            onContextMenu={(e)=> e.preventDefault()}
            onMouseEnter={() => this.state.enabled ? this.startRotation() : null}
            onMouseLeave={() => this.state.enabled ? this.stopRotation() : null}
        />
    }
}

ImageRotation.defaultProps = {
    srcs: [''],
    onLoad: () => {
    },
    onError: () => {
    },
    interval: 1000
};
